import { CartWarningContent, CartWarningWrapper } from "./CartWarning.styled";

type CartWarningProps = {
  children: React.ReactNode;
  hidden?: boolean;
};

function CartWarning({ children, hidden }: CartWarningProps): JSX.Element {
  return (
    <CartWarningWrapper className={hidden ? "hidden" : ""}>
      <CartWarningContent className={hidden ? "hidden" : ""}>
        {children}
      </CartWarningContent>
    </CartWarningWrapper>
  );
}

export { CartWarning };
